import { Reveal, SectionLabel } from "@/components/Reveal";

const LOGOS_A = [
  "figma", "react", "nextdotjs", "framer", "webflow", "wix", "elementor", "wordpress",
  "shopify", "typescript", "nodedotjs", "tailwindcss", "threedotjs", "blender", "unrealengine", "greensock",
];
const LOGOS_B = [
  "instagram", "pinterest", "threads", "reddit", "behance", "dribbble", "facebook", "youtube", "x", "tiktok",
];
const MONO = [
  { l: "Ps", c: "#31A8FF" }, { l: "Ai", c: "#FF9A00" }, { l: "Lr", c: "#5FA9F8" },
  { l: "Cdr", c: "#2FA44F" }, { l: "in", c: "#0A66C2" },
];
const FISH = [
  "Real Estate", "Hotels & Resorts", "Healthcare", "Coaches", "Interior Design", "D2C Brands",
  "Fashion & Apparel", "Manufacturing", "Automotive", "Finance & Banking", "Education", "SaaS & Tech",
  "Food & Beverage", "Beauty & Cosmetics", "Jewellery", "Fitness & Wellness", "Travel & Tourism",
  "E-commerce", "Media & Entertainment", "Events",
];

const LogoTile = ({ slug }) => (
  <div className="grid h-16 w-16 sm:h-20 sm:w-20 shrink-0 place-items-center rounded-2xl glass transition-transform duration-300 hover:scale-110 hover:border-[var(--border-hover)]">
    <img src={`https://cdn.simpleicons.org/${slug}`} alt={slug} loading="lazy" className="h-7 w-7 sm:h-9 sm:w-9" />
  </div>
);

const MonoTile = ({ m }) => (
  <div className="grid h-16 w-16 sm:h-20 sm:w-20 shrink-0 place-items-center rounded-2xl glass transition-transform duration-300 hover:scale-110 hover:border-[var(--border-hover)]">
    <span className="font-display font-extrabold text-lg sm:text-2xl" style={{ color: m.c }}>{m.l}</span>
  </div>
);

const FishPill = ({ name }) => (
  <span className="inline-flex shrink-0 items-center gap-2 rounded-full border border-[var(--border-hover)] bg-[var(--bg-primary)]/70 px-6 py-3 font-heading text-sm sm:text-base text-[var(--text-primary)] whitespace-nowrap backdrop-blur transition-transform duration-300 hover:scale-105">
    <span className="text-[var(--accent-primary)]">✦</span> {name}
  </span>
);

const Row = ({ children, reverse = false, gap = "gap-4 sm:gap-6" }) => (
  <div className="relative overflow-hidden marquee-pause">
    <div className={`flex w-max ${gap} ${reverse ? "animate-marquee-rev" : "animate-marquee"}`}>
      {children}
      {children}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-32 bg-gradient-to-r from-[var(--bg-secondary)] to-transparent z-10" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-32 bg-gradient-to-l from-[var(--bg-secondary)] to-transparent z-10" />
  </div>
);

export const FloatingStack = () => (
  <section data-testid="floating-stack" className="relative border-y border-[var(--border-subtle)] bg-[var(--bg-secondary)] overflow-hidden">
    <div className="pointer-events-none absolute inset-0 opacity-40" style={{ background: "radial-gradient(120% 80% at 50% 120%, var(--glow-color), transparent 65%)" }} />

    <div className="relative mx-auto max-w-[1400px] px-6 sm:px-10 py-24 lg:py-32">
      <Reveal>
        <SectionLabel>Our stack · industries</SectionLabel>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.02] max-w-2xl">
            The tools behind <span className="text-gradient">the magic.</span>
          </h2>
          <p className="max-w-sm font-body text-[var(--text-secondary)]">
            Every platform and tool we design, build and market with — flowing endlessly, with the
            worldwide industries we serve running alongside.
          </p>
        </div>
      </Reveal>

      <div className="space-y-5 sm:space-y-6">
        <Row>
          {LOGOS_A.map((s, i) => <LogoTile key={`a-${i}`} slug={s} />)}
          {MONO.map((m, i) => <MonoTile key={`m-${i}`} m={m} />)}
        </Row>

        <Row reverse gap="gap-3 sm:gap-4">
          {FISH.map((n, i) => <FishPill key={`f-${i}`} name={n} />)}
        </Row>

        <Row>
          {LOGOS_B.map((s, i) => <LogoTile key={`b-${i}`} slug={s} />)}
          {LOGOS_A.slice(0, 8).map((s, i) => <LogoTile key={`c-${i}`} slug={s} />)}
        </Row>
      </div>
    </div>
  </section>
);
